import { designToken, quickProperty } from '../component-tokens';
import { borderBase } from './common';
export const navigationRailsData = {
    name: 'navigation-rail',
    tag: 'chameleon-navigation-rail',
    reactImports: 'NavigationRail, NavigationRailItem',
    attributes: {
        'border-right-width': quickProperty('1px'),
        'border-right-style': quickProperty('solid'),
        'border-right-color': designToken('navigation-rail-border-right'),
        display: quickProperty('flex'),
        'flex-direction': quickProperty('column'),
        'background-color': designToken('navigation-rail-background'),
        padding: quickProperty('8px 0'),
        width: quickProperty('72px'),
        'box-sizing': quickProperty('border-box'),
    },
    children: [
        {
            name: 'item',
            attributes: Object.assign(Object.assign({}, borderBase), { width: quickProperty('72px'), 'min-height': quickProperty('72px'), 'border-color': quickProperty('transparent'), display: quickProperty('flex'), outline: quickProperty('0'), cursor: quickProperty('pointer'), 'box-sizing': quickProperty('border-box'), 'flex-direction': quickProperty('column'), color: designToken('navigation-rail-text'), font: designToken('caption-small-strong'), gap: quickProperty('4px'), 'align-items': quickProperty('center'), 'justify-content': quickProperty('center'), '--goto-icon-size': quickProperty('24px'), '--goto-icon-color': designToken('navigation-rail-icon'), padding: quickProperty('14px 2px'), position: quickProperty('relative'), 'text-decoration': quickProperty('none') }),
            states: [
                {
                    name: 'hover',
                    attributes: {
                        'background-color': designToken('navigation-rail-item-hover'),
                    },
                },
                {
                    name: 'active',
                    attributes: {
                        'background-color': designToken('navigation-rail-item-active'),
                    },
                },
                {
                    name: 'focus',
                    attributes: {
                        'border-color': designToken('navigation-rail-focus'),
                        'box-shadow': designToken('navigation-rail-highlight'),
                    },
                },
                {
                    name: 'selected',
                    attributes: {
                        'background-color': designToken('navigation-rail-item-selected'),
                        color: designToken('navigation-rail-text-selected'),
                        '--goto-icon-color': designToken('navigation-rail-icon-selected'),
                    },
                },
                {
                    name: 'disabled',
                    attributes: {
                        'background-color': designToken('navigation-rail-item-disabled'),
                        color: designToken('navigation-rail-text-disabled'),
                        '--goto-icon-color': designToken('navigation-rail-icon-disabled'),
                        'pointer-events': quickProperty('none'),
                    },
                },
            ],
            children: [
                {
                    name: 'content',
                    attributes: {
                        display: quickProperty('inline-flex'),
                        hyphens: quickProperty('auto'),
                        'text-align': quickProperty('center'),
                        'word-break': quickProperty('break-word'),
                    },
                },
                {
                    name: 'badge',
                    attributes: {
                        position: quickProperty('absolute'),
                        right: designToken('spacing-02'),
                        top: designToken('spacing-03'),
                    },
                },
            ],
        },
    ],
};
